import React, { useState } from 'react';
import { PaisMercadoGlobalEnum } from '../../../../common/types/enums/pais-mercado-global.enum';
import { MaskedInput } from '../../../atoms/input/input.atom';

type Props = {
  country: PaisMercadoGlobalEnum;
  value: string;
  onChange: (value: string) => void;
  id?: string;
  color?: string;
};

export const ZipCodeInput: React.FC<Props> = ({
  value,
  onChange,
  country,
  id,
  color,
}) => {
  const [mask, setMask] = useState(() =>
    country === PaisMercadoGlobalEnum.EUA ? '99999' : '99999-999',
  );

  const handleKeyDown = () => {
    const numeric = value.replace(/\D/g, '');

    if (country === PaisMercadoGlobalEnum.EUA) {
      if (numeric.length >= 5 && mask !== '99999-9999') {
        setMask('99999-9999');
      }
      if (numeric.length < 5 && mask !== '99999') {
        setMask('99999');
      }
    } else {
      if (mask !== '99999-999') {
        setMask('99999-999');
      }
    }
  };

  return (
    <MaskedInput
      color={color}
      id={id}
      mask={mask}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      onKeyDown={handleKeyDown}
      maskChar=""
      placeholder={mask}
    />
  );
};
